<template>
  <div class="row justify-content-center">
    <div class="col col-md-6 mt-4">
      <Card v-if="didConsumeToken"
        :bgclass="card_bgclass"
        :textclass="card_textclass"
        :header="card_header"
        :title="card_title"
        :text="card_text" />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Card from '@/components/Card.vue'

export default {
  name: 'JoinOrgRequestPage',
  components: {
    Card
  },
  data () {
    return {
      didConsumeToken: false,
      card_bgclass: null, // 'danger',
      card_textclass: null, // 'white',
      card_header: null, // 'Join Organization Request Error',
      card_title: null, // 'Unable to add user',
      card_text: null // 'Something went wrong while attempting to add a user to your organization.  This may be due to an expired link, an error in the system, or something else.'
    }
  },
  mounted () {
    this.consumeToken()
  },
  methods: {
    ...mapActions('auth', ['joinOrgResponse']),
    consumeToken () {
      this.joinOrgResponse({ token: this.$route.params.token })
        .then(({ accepted, user, org }) => {
          if (accepted) {
            this.markAccepted({
              header: 'Join Organization Request',
              title: 'Success',
              text: '<strong>' + user.fname + ' ' + user.lname + '</strong> has been added to the organization <strong>' + org.name + '</strong>.  They are now active and will receive a notification email shortly.'
            })
          } else {
            this.markDenied({
              header: 'Join Organization Request',
              title: 'Request Denied',
              text: '<strong>' + user.fname + ' ' + user.lname + '</strong>\'s request to join <strong>' + org.name + '</strong> has been denied.  They will receive a notification email shortly.'
            })
          }
        })
        .catch((err) => {
          console.log(err)
          this.markError({
            header: 'Join Organization Request',
            title: 'Something went wrong',
            text: '<strong>Error:</strong> ' + err.message
          })
        })
    },
    markAccepted ({ header, title, text }) {
      this.card_bgclass = 'success'
      this.card_textclass = 'white'
      this.card_header = header
      this.card_title = title
      this.card_text = text
      this.didConsumeToken = true
    },
    markDenied ({ header, title, text }) {
      this.card_bgclass = 'info'
      this.card_textclass = 'white'
      this.card_header = header
      this.card_title = title
      this.card_text = text
      this.didConsumeToken = true
    },
    markError ({ header, title, text }) {
      this.card_bgclass = 'danger'
      this.card_textclass = 'white'
      this.card_header = header
      this.card_title = title
      this.card_text = text
      this.didConsumeToken = true
    }
  }
}

</script>
